import React, { FC } from 'react';
import { Actions } from '../../redux/actions';
import { UUID } from '../../redux/models';
import { ExtraDimensions } from './extraDimensions.component';
import { useDispatch, useSelector } from 'react-redux';
import './extraDimensions.style.scss';
import { useHistory } from 'react-router';
import { AppState } from '../../redux/redux.model';
import { isWorkspaceLevelMethodology } from '../../redux/methodologyDeep/scope';

const { deleteExtraDimensionMethodologyDeep } = Actions;

export interface ResourceProps {
  id: UUID;
  title: string;
  inspectionGroupId: UUID;
}

export const ExtraDimensionsWrapper: FC<ResourceProps> = ({ id, title, inspectionGroupId }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const workspaceId = useSelector((state: AppState) => state.MethodologyDeep.methodologyDeep?.workspace_id);
  const companyIdField = useSelector((state: AppState) => state.MethodologyDeep.methodologyDeep?.company_id);
  const companyObjectId = useSelector((state: AppState) => state.MethodologyDeep.methodologyDeep?.company?.id);
  const isWorkspaceMethodology = isWorkspaceLevelMethodology({
    workspace_id: workspaceId,
    company_id: companyIdField,
    company: companyObjectId ? { id: companyObjectId } : null
  });
  const remove = extraDimensionId => {
    dispatch(deleteExtraDimensionMethodologyDeep({ extraDimensionId, inspectionGroupId }));
  };
  const edit = (extraDimensionId, companyId, methodologyId) => {
    if (isWorkspaceMethodology && workspaceId) {
      history.push(
        `/extra-dimensions/${extraDimensionId}/by-workspace/${workspaceId}/by-methodology/${methodologyId}/inspection-group/${inspectionGroupId}`
      );
      return;
    }
    history.push(
      `/extra-dimensions/${extraDimensionId}/by-company/${companyId}/by-methodology/${methodologyId}/inspection-group/${inspectionGroupId}`
    );
  };
  return <ExtraDimensions id={id} title={title} deleteFn={remove} editFn={edit} />;
};

export default ExtraDimensionsWrapper;
